import { render, staticRenderFns } from "./Takeout.vue?vue&type=template&id=32e050d8&"
import script from "./Takeout.vue?vue&type=script&lang=ts&"
export * from "./Takeout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports